(() => {
  "use strict";
  if (window.__pwmLoaded) return;
  window.__pwmLoaded = true;
  const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
  const product=$(".hero[data-one-id]");
  const currency=window.Shopify?.currency?.active || "USD";
  const money=c=>new Intl.NumberFormat("en-US",{style:"currency",currency}).format(c/100);
  const icon=n=>`<svg class="icon" aria-hidden="true"><use href="#i-${n}"></use></svg>`;
  let selected="single", currentCart=null, busy=false;
  const esc=s=>String(s??"").replace(/[&<>"']/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));
  const dialog=$("#cart-dialog");
  const list=()=>fetch("/cart.js",{credentials:"same-origin"}).then(r=>r.json());
  const post=(path,data)=>fetch(path,{method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify(data)})
    .then(async r=>{const data=await r.json();if(!r.ok)throw new Error(data.description||"Cart could not be updated");return data});
  const close=d=>{if(d?.open)d.close();document.body.classList.remove("locked")};
  function open(d){if(!d?.open){d.showModal();document.body.classList.add("locked")}}
  $$("dialog").forEach(d=>d.addEventListener("close",()=>document.body.classList.remove("locked")));
  $(".menu-toggle")?.addEventListener("click",e=>{
    const open=$(".nav")?.classList.toggle("open");
    e.currentTarget.setAttribute("aria-expanded",String(!!open));
    e.currentTarget.setAttribute("aria-label",open?"Close menu":"Open menu");
  });
  $(".cart-trigger")?.addEventListener("click",async()=>{await refreshCart();open(dialog)});
  $("[data-close-cart]")?.addEventListener("click",()=>close(dialog));
  $("[data-close-photo]")?.addEventListener("click",()=>close($("#photo-dialog")));
  $(".zoom-button")?.addEventListener("click",()=>{
    const photo=$("#photo-dialog img"),main=$("#gallery-main");if(!photo||!main)return;
    photo.src=main.src;photo.removeAttribute("loading");photo.alt=main.alt;open($("#photo-dialog"));
  });
  $$(".thumb").forEach((b,i)=>b.addEventListener("click",()=>{
    $$(".thumb").forEach(t=>{t.classList.toggle("active",t===b);t.setAttribute("aria-pressed",String(t===b))});
    const gm=$("#gallery-main");if(b.dataset.srcset)gm.srcset=b.dataset.srcset;else gm.removeAttribute("srcset");gm.src=b.dataset.photo;
    $("#gallery-main").alt=b.dataset.alt || "";
    $("#gallery-caption").textContent=b.dataset.caption||"";
    $("#gallery-index").textContent=String(i+1).padStart(2,"0")+" / "+String($$(".thumb").length).padStart(2,"0");
    $(".gallery-stage").classList.toggle("photo-real",i>0);
  }));
  let touchStart=0;
  $("#gallery-main")?.addEventListener("touchstart",e=>touchStart=e.touches[0].clientX,{passive:true});
  $("#gallery-main")?.addEventListener("touchend",e=>{
    const delta=e.changedTouches[0].clientX-touchStart;
    if(Math.abs(delta)<45)return;
    const buttons=$$(".thumb"),idx=buttons.indexOf($(".thumb.active"));
    buttons[(idx+(delta<0?1:-1)+buttons.length)%buttons.length].click();
  },{passive:true});
  function led(on) {
    $("#led-toggle")?.setAttribute("aria-checked",String(on));
    if($("#led-label"))$("#led-label").textContent=on?"LED on":"LED off";
    if($("#led-photo")){
      $("#led-photo").src=on?$("#led-photo").dataset.on:$("#led-photo").dataset.off;
      $("#led-photo").alt="Retouched studio view of Pawmute with LED "+(on?"on":"off");
    }
    $$(".feature-tab").forEach(t=>{const active=t.dataset.feature==="light"&&on;t.classList.toggle("selected",active);t.setAttribute("aria-pressed",String(active))});
  }
  $("#led-toggle")?.addEventListener("click",()=>led($("#led-toggle").getAttribute("aria-checked")!=="true"));
  $$(".feature-tab").forEach(t=>t.addEventListener("click",()=>{
    $$(".feature-tab").forEach(x=>{x.classList.toggle("selected",x===t);x.setAttribute("aria-pressed",String(x===t))});
    if(t.dataset.feature==="light")led(true);
    else {$("#led-toggle")?.setAttribute("aria-checked","false");
      if($("#led-label"))$("#led-label").textContent="LED off";
      if($("#led-photo"))$("#led-photo").src=t.dataset.feature==="blade"?$("#led-photo").dataset.blade:$("#led-photo").dataset.off;
    }
  }));
  $$(".faq-list details").forEach(d=>d.addEventListener("toggle",()=>{if(d.open)$$(".faq-list details").forEach(o=>{if(o!==d)o.open=false})}));
  function selection(){
    if(!product)return;
    selected=$('input[name="offer"]:checked')?.value||"single";
    const isTwo=selected==="double",c=Number(product.dataset[isTwo?"twoPrice":"onePrice"]);
    const addon=$('.pwm-buy-form .addon input:checked')?.closest(".addon"),extra=addon?Number(addon.dataset.addonPrice):0;
    $$(".selected-price").forEach(x=>x.textContent=money(c+extra));
    $$(".selected-name").forEach(x=>x.textContent=(isTwo?"2 trimmers":"1 trimmer")+(addon?" + nail grinder":""));
    const id=product.dataset[isTwo?"twoId":"oneId"];
    $('.pwm-buy-form [name="id"]').value=id;
  }
  $$('input[name="offer"], .pwm-buy-form .addon input').forEach(x=>x.addEventListener("change",selection));
  selection();
  async function add(){
    if(!product||busy)return;
    busy=true;const id=product.dataset[selected==="double"?"twoId":"oneId"];
    const addon=$('.pwm-buy-form .addon input:checked');
    const items=[{id:Number(id),quantity:1}];if(addon)items.push({id:Number(addon.value),quantity:1});
    try{await post("/cart/add.js",{items});await refreshCart();open(dialog)}
    catch(error){alert(error.message);/* native form remains available if scripting fails */}
    finally{busy=false}
  }
  $(".pwm-buy-form")?.addEventListener("submit",e=>{e.preventDefault();e.stopImmediatePropagation();add()},true);
  $(".sticky-buy [data-add]")?.addEventListener("click",add);
  const gForm=$(".pwm-grinder-form");
  function gSel(){if(!gForm)return;const o=$('input[name="grinder_offer"]:checked',gForm);if(!o)return;
    $$(".g-selected-price").forEach(x=>x.textContent=money(Number(o.dataset.price)));
    $$(".g-selected-name").forEach(x=>x.textContent=o.dataset.label||"");}
  $$('input[name="grinder_offer"]').forEach(x=>x.addEventListener("change",gSel));gSel();
  const gAdd=()=>{const o=$('input[name="grinder_offer"]:checked',gForm);if(o)addKit(o.value.split(","))};
  gForm?.addEventListener("submit",e=>{e.preventDefault();e.stopImmediatePropagation();gAdd()},true);
  $$("[data-grinder-add]").forEach(b=>b.addEventListener("click",gAdd));
  if(gForm&&$(".sticky-buy")){const dock=$(".sticky-buy");new IntersectionObserver(([en])=>{const show=!en.isIntersecting&&en.boundingClientRect.bottom<0;dock.hidden=!show;document.body.classList.toggle("has-dock",show)}).observe($(".add-button",gForm))}
  const kit=dialog?.dataset||{};
  const isTrimmer=item=>item.handle===kit.trimmerHandle;
  const isGrinder=item=>item.handle===kit.grinderHandle;
  function rowImage(item){return (isTrimmer(item)&&kit.cartImage)||item.featured_image?.url||item.image||""}
  async function addKit(ids){if(busy)return;busy=true;try{await post("/cart/add.js",{items:ids.filter(Boolean).map(id=>({id:Number(id),quantity:1}))});await refreshCart();open(dialog)}catch(err){alert(err.message);await refreshCart().catch(()=>{})}finally{busy=false}}
  window.pwmAddKit=addKit;
  function cartMarkup(cart){
    const items=cart.items||[];
    let body=items.length?`<div class="cart-free">${icon("truck")}Your order includes free US shipping.</div>`:
      `<div class="empty-cart">${icon("bag")}<h3>A little room for paw care.</h3><p>Your bag is empty. Find the right kit for your pet.</p><a href="/products/quiet-led-paw-trimmer-dogs-cats-rechargeable#buy" class="button button-primary">Explore the trimmer ${icon("arrow")}</a></div>`;
    items.forEach((item,i)=>{
      const image=rowImage(item);
      body+=`<article class="cart-line${isTrimmer(item)?"":" cart-line-contain"}"><img src="${esc(image)}" alt="${esc(item.product_title)}"><div><div class="cart-line-top"><h3>${esc(isTrimmer(item)?"Quiet Paw Trimmer":isGrinder(item)?"Quiet Nail Grinder":item.product_title)}</h3><strong>${item.original_line_price>item.final_line_price?`<del>${money(item.original_line_price)}</del> `:""}${money(item.final_line_price)}</strong></div><p>${esc(item.variant_title||"")}</p><div class="cart-line-controls"><div class="quantity"><button type="button" data-line="${i+1}" data-qty="${item.quantity-1}" aria-label="Decrease ${esc(item.variant_title)} quantity">−</button><span>${item.quantity}</span><button type="button" data-line="${i+1}" data-qty="${item.quantity+1}" aria-label="Increase ${esc(item.variant_title)} quantity">+</button></div><button type="button" class="remove-line" data-line="${i+1}" data-qty="0">Remove</button></div></div></article>`;
    });
    const hasTrimmer=items.some(isTrimmer),hasGrinder=items.some(isGrinder);
    if(hasTrimmer&&!hasGrinder&&kit.grinderId)
      body+=`<div class="cart-upsell cart-upsell-kit">${kit.grinderImage?`<img src="${esc(kit.grinderImage)}" alt="" width="64" height="64">`:""}<div><h3>Finish with the nails.</h3><p>Add the Quiet Nail Grinder for <strong>${money(Number(kit.grinderPrice))}</strong> <del>${money(Number(kit.grinderRegular))}</del> with your trimmer.</p></div><button type="button" class="button button-outline" data-add-kit="${esc(kit.grinderId)}">Add the nail grinder ${icon("plus")}</button></div>`;
    else if(hasGrinder&&!hasTrimmer&&kit.trimmerId)
      body+=`<div class="cart-upsell"><h3>Make it the Quiet Paw Kit.</h3><p>Add the LED Quiet Paw Trimmer for ${money(Number(kit.trimmerPrice))} and your grinder drops to ${money(Number(kit.grinderPrice))}.</p><button type="button" class="button button-outline" data-add-kit="${esc(kit.trimmerId)}">Add the trimmer ${icon("plus")}</button></div>`;
    else if(product&&items.filter(isTrimmer).length===1&&items.some(x=>String(x.variant_id)===product.dataset.oneId&&x.quantity===1))
      body+=`<div class="cart-upsell"><h3>One for you. One to share.</h3><p>Choose the two-trimmer offer for ${money(Number(product.dataset.twoPrice))} total.</p><button type="button" class="button button-outline" data-upgrade>Switch to two trimmers ${icon("arrow")}</button></div>`;
    const bottom=items.length?`<div class="cart-total"><span>Subtotal</span><span>${money(cart.total_price)}</span></div><p>Free US shipping. Any applicable taxes calculated at checkout.</p><a class="button button-primary" href="/checkout">Continue to Shopify checkout ${icon("arrow")}</a><p class="cart-guarantee">${icon("shield")}60-day money-back guarantee</p>`:"";
    return [body,bottom];
  }
  async function refreshCart(){
    currentCart=await list();
    $$(".cart-count").forEach(n=>n.textContent=currentCart.item_count);
    const [body,bottom]=cartMarkup(currentCart);
    $$(".cart-content").forEach(n=>n.innerHTML=body);
    $$(".cart-bottom").forEach(n=>n.innerHTML=bottom);
    return currentCart;
  }
  document.addEventListener("click",async e=>{
    const change=e.target.closest("[data-line][data-qty]");
    const upgrade=e.target.closest("[data-upgrade]");
    const kitBtn=e.target.closest("[data-add-kit]");
    if(kitBtn){addKit(kitBtn.dataset.addKit.split(","));return}
    if(change&&!busy){busy=true;try{await post("/cart/change.js",{line:Number(change.dataset.line),quantity:Number(change.dataset.qty)});await refreshCart()}catch(err){alert(err.message)}finally{busy=false}}
    if(upgrade&&!busy&&product){busy=true;try{
      const cart=currentCart||await list(),idx=cart.items.findIndex(x=>String(x.variant_id)===product.dataset.oneId);
      if(idx<0)return;
      await post("/cart/change.js",{line:idx+1,quantity:0});
      await post("/cart/add.js",{id:product.dataset.twoId,quantity:1});
      await refreshCart();
    }catch(err){alert(err.message);await refreshCart()}finally{busy=false}}
  });
  if(product&&$(".sticky-buy")){
    const dock=$(".sticky-buy");
    const observer=new IntersectionObserver(([entry])=>{
      const show=!entry.isIntersecting&&entry.boundingClientRect.bottom<0;
      dock.hidden=!show;document.body.classList.toggle("has-dock",show);
    });observer.observe($(".pwm-buy-form .add-button"));
  }
  if(!matchMedia("(prefers-reduced-motion: reduce)").matches){
    const observer=new IntersectionObserver(entries=>entries.forEach(e=>{
      if(e.isIntersecting){e.target.classList.remove("pending");observer.unobserve(e.target)}
    }),{threshold:0,rootMargin:"0px 0px 20% 0px"});
    $$(".reveal").forEach(e=>{e.classList.add("pending");observer.observe(e)});
  }
  refreshCart().catch(()=>{});
  document.addEventListener("shopify:section:load",()=>refreshCart().catch(()=>{}));
})();
